export const GetChangedFields = (newValues?: Object, oldValues?: Object) => (
    newValues ? Object.keys(newValues).filter(key => newValues[key] !== oldValues?.[key]) : []
)